module.exports = __webpack_public_path__ + "static/media/logo_arabic.447b27dc.svg";